import './index.scss';
import React from 'react';
import { useGrid } from '../../../provider';
import Header from './header';
import Result from './result';
const ClassificationResults = ({ filteredCategories, filteredDescriptors, }) => {
    const { selectedCategories, setSelectedCategories, selectedDescriptors, setSelectedDescriptors, } = useGrid();
    return React.createElement("div", { className: 'overflow-scroll-gradient' },
        React.createElement("div", { className: 'classification-results' },
            React.createElement(Header, { filteredResults: filteredCategories, setSelectedResults: setSelectedCategories },
                React.createElement("b", null, "CATEGORY")),
            React.createElement("div", { className: 'classification-results-list' }, filteredCategories.map(filteredCategory => {
                return React.createElement(Result, { key: filteredCategory, result: filteredCategory, selectedResults: selectedCategories, setSelectedResults: setSelectedCategories });
            }))),
        React.createElement("div", { className: 'classification-results' },
            React.createElement(Header, { filteredResults: filteredDescriptors, setSelectedResults: setSelectedDescriptors },
                React.createElement("b", null, "DESCRIPTOR")),
            React.createElement("div", { className: 'classification-results-list' }, filteredDescriptors.map(filteredDescriptor => {
                return React.createElement(Result, { key: filteredDescriptor, result: filteredDescriptor, selectedResults: selectedDescriptors, setSelectedResults: setSelectedDescriptors });
            }))));
};
export default ClassificationResults;
